// extracted by mini-css-extract-plugin
export default {"galleryList":"gallery_galleryList__zUbGP","galleryItem":"gallery_galleryItem__KpST6","galleryPhotoWide":"gallery_galleryPhotoWide__PjKPn","buttonTop":"gallery_buttonTop__AYfPg"};